<!--  -->
<template>
  <div class="table_box">
    <div class="template_box">
      <div class="search_box">
        <el-select v-model="policyobj.platform_id" filterable placeholder="请选择策略平台">
          <el-option
            v-for="item in accoutarr"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <el-select v-model="policyobj.strategy_type" filterable placeholder="请选择策略类型">
          <el-option
            v-for="item in customerarr"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          />
        </el-select>
        <el-select v-model="policyobj.onlyMe" placeholder="请选择">
          <el-option
            v-for="item in accountarr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-input v-model="policyobj.strategy_no" style="width:200px;" placeholder="请输入策略编号" />
        <el-input v-model="policyobj.strategy_name" style="width:200px;" placeholder="请输入策略标题" />
        <el-button class="search" type="primary" icon="el-icon-search" style="margin:0" @click="searchr">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" style="margin:0" @click="resetclick">重置</el-button>
      </div>
      <div>
        <el-button type="success" icon="el-icon-plus" @click="addarcadestrategy">新增策略</el-button>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      :data="tableData.list"
      border
      tooltip-effect="dark"
      style="width: 100%;margin-top:20px"
    >
      <!-- <el-table-column
        type="selection"
        width="55"
      /> -->
      <el-table-column
        align="center"
        width="160"
        prop="strategyNo"
        label="策略编号"
      />
      <el-table-column
        align="center"
        prop="platformStr"
        width="80"
        label="策略平台"
      />
      <el-table-column
        align="center"
        prop="strategyName"
        label="标题"
        width="150"
      />
      <el-table-column
        prop="created_at_text"
        label="发送群体"
        width="350"
        align="center"
      >
        <template slot-scope="scope">
          <div v-html="scope.row.userWheresText" />
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="strategyTypeStr"
        label="类型"
      />
      <el-table-column
        align="center"
        prop="statusStr"
        label="状态"
      >
        <template slot-scope="scope">
          <i v-if="scope.row.status == 1" class="el-icon-success defaultr" />
          {{ scope.row.statusStr }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="creator"
        width="80"
        label="创建人"
      />

      <el-table-column
        align="center"
        prop="createdAt"
        width="150"
        label="创建时间"
      />

      <el-table-column
        align="center"
        label="操作"
        width="280"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="bandclick(scope.row)">绑定公众号</el-button>
          <el-button type="info" size="small" @click="multiplexingone(scope.row)">编辑</el-button>
          <el-dropdown trigger="click" @command="(cmd) => handleMoreCommand(cmd, scope.row)">
            <el-button size="small" type="primary" style="margin-left: 10px;">
              更多<i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="multiplexing">复用</el-dropdown-item>
              <el-dropdown-item command="unbind">绑定记录</el-dropdown-item>
              <el-dropdown-item v-if="scope.row.strategyType == 3" command="sendrecord">发送记录</el-dropdown-item>
              <el-dropdown-item command="delete" divided>
                <span class="dropdown-item--danger">删除</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>

    </el-table>
    <pagination-right
      :current-page="policyobj.page"
      :total="tableData.total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

    <el-dialog
      title="新增策略"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="close"
    >
      <Strategyfactory v-if="showr" />
    </el-dialog>

    <el-dialog
      title="绑定公众号"
      :visible.sync="dialogVisiblebind"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
    >
      <Bindofficialaccountdia ref="bindaccout" @closedialog="closedialog" @closeAndB="closeAndB" />
    </el-dialog>

    <el-dialog
      title="绑定记录"
      :visible.sync="dialogVisibleunbind"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
    >
      <Unbindofficialaccountdia ref="unbindaccout" @unbink="unbink" />
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="AandBdialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      :destroy-on-close="true"
    >
      <bandAandB ref="bandAandBview" @saveupdata="saveupdata" />
    </el-dialog>

    <el-dialog
      title="发送记录"
      :visible.sync="dialogVisibleSendRecord"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      width="1000px"
      append-to-body
    >
      <timingtable v-if="dialogVisibleSendRecord" :id="sendRecordStrategyNo" />
    </el-dialog>
  </div>
</template>

<script>
import { policylist, strategyList, strategyPlatform, deleteaccountitem } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import Strategyfactory from './components/Strategyfactory.vue'
import Bindofficialaccountdia from './components/Bindofficialaccountdia.vue'
import Unbindofficialaccountdia from './components/Unbindofficialaccountdia.vue'
import bandAandB from './components/bandAandB.vue'
import timingtable from '../newPolicy/components/timingtable.vue'
import convertToHump from '@/utils/mixins/convertToHump.js'
export default {
  components: {
    PaginationRight,
    Strategyfactory,
    Bindofficialaccountdia,
    Unbindofficialaccountdia,
    bandAandB,
    timingtable
  },
  mixins: [convertToHump],
  data() {
    return {

      showr: false,
      customerarr: [],
      tableData: [],
      dialogVisible: false,
      dialogVisiblebind: false,
      dialogVisibleunbind: false,
      dialogVisibleSendRecord: false,
      sendRecordStrategyNo: '',
      AandBdialogVisible: false,
      accoutarr: [],
      policyobj: {
        page: 1,
        pageSize: 10,
        platform_id: null,
        strategy_type: null,
        strategy_no: null,
        strategy_name: null,
        onlyMe: 2
      },
      accountarr: [{
        value: 1,
        label: '查看组内策略'
      }, {
        value: 2,
        label: '我关联的策略'
      }]
    }
  },
  activated() {
    this.getpolicylist()
    this.getstrategyListr()
    this.getstrategyplatform()
    console.log(this.$route.query.ids)
    // this.policyobj.strategy_no = this.$route.query.ids ? this.$route.query.ids : null
    if (this.$route.query.ids) {
      this.policyobj.strategy_no = this.$route.query.ids
    }
  },
  created() {
    this.getpolicylist()
    this.getstrategyListr()
    this.getstrategyplatform()
    console.log(this.$route.query.ids)
    this.policyobj.strategy_no = this.$route.query.ids ? this.$route.query.ids : null
  },
  mounted() {

  },
  methods: {
    saveupdata() {
      this.AandBdialogVisible = false
      this.getpolicylist()
    },
    // 策略列表
    async getpolicylist() {
      const data = await policylist(this.policyobj)
      this.tableData = this.convertToHump(data.data.data)
      console.log('策略列表', this.tableData)
    },
    // 获取策略类型
    async getstrategyListr() {
      const data = await strategyList()
      this.customerarr = this.convertToHump(data.data)
      console.log('策略类型', data)
    },
    // 获取策略平台
    async getstrategyplatform() {
      const data = await strategyPlatform()
      this.accoutarr = this.convertToHump(data.data.list)
      console.log('获取策略平台', data)
    },
    // 分页
    fetchPageSize(e) {
      this.policyobj.pageSize = e
      this.getpolicylist()
    },
    fetchCurrentPage(e) {
      this.policyobj.page = e
      this.getpolicylist()
    },
    resetclick() {
      this.policyobj = {
        page: 1,
        pageSize: 10,
        platform_id: null,
        strategy_type: null,
        strategy_no: null,
        strategy_name: null,
        onlyMe: 2
      }
      this.getpolicylist()
    },
    // 绑定公众号
    bandclick(item) {
      console.log('item', item)
      this.dialogVisiblebind = true
      // 通用绑定逻辑
      // eslint-disable-next-line eqeqeq
      // if (item.platformId == 99) {
      //   setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
      //     this.$refs.bindaccout.send(item, 3)
      //   }, 100)
      // } else {
      //   setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
      //     this.$refs.bindaccout.send(item)
      //   }, 100)
      // }
      // 正常的逻辑
      // eslint-disable-next-line eqeqeq
      if (item.platformId == 99) {
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.bindaccout.send(item, 2)
        }, 100)
      } else {
        setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
          this.$refs.bindaccout.send(item)
        }, 100)
      }
    },
    // 解绑公众号
    unbindclick(item) {
      console.log('item', item)
      this.dialogVisibleunbind = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.unbindaccout.send(item.strategyNo, item.officialAccounts)
      }, 100)
    },
    addarcadestrategy() {
      // this.dialogVisible = true
      // this.showr = true
      this.$router.push({ path: '/newPolicy/index' })
    },
    close() {
      this.dialogVisible = false
      this.showr = false
    },
    closedialog() {
      this.dialogVisiblebind = false
      this.getpolicylist()
    },
    closeAndB(val, strategy_no, arrsw) {
      this.dialogVisiblebind = false
      this.AandBdialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.bandAandBview.send(val, strategy_no, arrsw, 1)
      }, 100)
    },
    unbink() {
      this.dialogVisibleunbind = false
      this.getpolicylist()
    },
    multiplexing(item) {
      console.log('item', item)
      this.$router.push({ path: '/newPolicy/index', query: { item: JSON.stringify(item.strategyNo), type: 1 }})
    },
    multiplexingone(item) {
      console.log('item', item)
      this.$router.push({ path: '/newPolicy/index', query: { item: JSON.stringify(item.strategyNo), type: 0 }})
    },
    handleMoreCommand(command, row) {
      if (command === 'multiplexing') {
        this.multiplexing(row)
      } else if (command === 'unbind') {
        this.unbindclick(row)
      } else if (command === 'sendrecord') {
        this.sendRecordStrategyNo = row.strategyNo
        this.dialogVisibleSendRecord = true
      } else if (command === 'delete') {
        this.deleteaccount(row.strategyNo)
      }
    },
    // 删除
    deleteaccount(id) {
      this.$confirm('确定要删除当前策略吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        deleteaccountitem({
          strategy_no: id
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.getpolicylist()
        })
      })
    },
    searchr() {
      this.policyobj.page = 1
      this.getpolicylist()
    }

  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.table_box{
  padding: 30px;
}
.template_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.template_input{
 width: 300px;
}
.search{
  margin-left: 20px;
}
.defaultr{
  color: #67C23A;
}
.dropdown-item--danger {
  color: #f56c6c;
}
</style>
